import React from "react";

import {
  Search
} from "lucide-react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TraceabilityFilterPanel({

  filters,

  projects,

  onChange,

  onApply

}) {

  return (

    <div style={styles.filterCard}>


      {/* ================================================================ */}
      {/* ROW 1 */}
      {/* ================================================================ */}
      <div style={styles.filterRow}>


        {/* PROJECT */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            Project
          </label>

          <select
            value={filters.project_id || ""}
            onChange={(e) =>
              onChange(
                "project_id",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL PROJECTS
            </option>

            {
                (projects || []).map((project) => (

                    <option
                    key={project.id}
                    value={project.id}
                    >

                    {project.project_name}

                    </option>
                ))
                }

          </select>

        </div>


        {/* STATUS */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            Lifecycle Status
          </label>

          <select
            value={filters.status || ""}
            onChange={(e) =>
              onChange(
                "status",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL STATUS
            </option>

            <option value="PLANNED">
  Planned
</option>

<option value="RESERVED">
  Reserved
</option>

<option value="IN_TRANSIT">
  In Transit
</option>

<option value="RECEIVED">
  Received
</option>

<option value="RECONCILED">
  Reconciled
</option>

<option value="ISSUED">
  Issued
</option>

          </select>

        </div>


        {/* VALIDATION */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            Validation
          </label>

          <select
            value={
              filters.validation_status || ""
            }
            onChange={(e) =>
              onChange(
                "validation_status",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL
            </option>

            <option value="OK">
              OK
            </option>

            <option value="ERROR">
              ERROR
            </option>

          </select>

        </div>


        {/* FROM DATE */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            From Date
          </label>

          <input
            type="date"
            value={filters.from_date || ""}
            onChange={(e) =>
              onChange(
                "from_date",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>


        {/* TO DATE */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            To Date
          </label>

          <input
            type="date"
            value={filters.to_date || ""}
            onChange={(e) =>
              onChange(
                "to_date",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>

      </div>


      {/* ================================================================ */}
      {/* ROW 2 */}
      {/* ================================================================ */}
      <div style={styles.filterRow}>


        {/* SEARCH */}
        <div
          style={{
            ...styles.filterGroup,
            flex: 1
          }}
        >

          <label style={styles.label}>
            Global Search
          </label>

          <div style={styles.searchBox}>


            <Search size={16} />


            <input
              type="text"
              placeholder={
                "Search material, packing list, receipt, vehicle..."
              }
              value={filters.search || ""}
              onChange={(e) =>
                onChange(
                  "search",
                  e.target.value
                )
              }
              style={styles.searchInput}
            />

          </div>

        </div>


        {/* APPLY */}
        <div style={styles.actionWrap}>


          <button
            style={styles.applyBtn}
            onClick={onApply}
          >

            Apply Filters

          </button>

        </div>

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  filterCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 16,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  filterRow: {

    display: "flex",

    gap: 16,

    flexWrap: "wrap",

    alignItems: "end",

    marginBottom: 16
  },

  filterGroup: {

    display: "flex",

    flexDirection: "column",

    minWidth: 220
  },

  label: {

    fontSize: 12,

    marginBottom: 6,

    color: "#374151",

    fontWeight: 600
  },

  select: {

    height: 40,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 10px",

    background: "#fff"
  },

  input: {

    height: 40,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 10px",

    background: "#fff"
  },

  searchBox: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px",

    background: "#fff",

    height: 40
  },

  searchInput: {

    border: "none",

    outline: "none",

    flex: 1,

    fontSize: 14
  },

  actionWrap: {

    display: "flex",

    alignItems: "end"
  },

  applyBtn: {

    height: 40,

    border: "none",

    background: "#2563eb",

    color: "#fff",

    borderRadius: 8,

    padding: "0 18px",

    cursor: "pointer",

    fontWeight: 600
  }
};